<template>
  <vx-card no-shadow>
    <div class="mb-base">
      <h6 class="mb-4">Activity</h6>

      <div class="flex items-center mb-4">
        <vs-switch v-model="failedEntries" />
        <span class="ml-4">Email me on all failed entries</span>
      </div>
      <div class="flex items-center mb-4">
        <vs-switch v-model="reportedEntries" />
        <span class="ml-4">Email me on all reported entries</span>
      </div>
      <div class="flex items-center mb-4">
        <vs-switch v-model="cloudifySupport" />
        <span class="ml-4">Email me when cloudify support writes back</span>
      </div>
    </div>

    <div>
      <h6 class="mb-4">Application</h6>

      <div class="flex items-center mb-4">
        <vs-switch v-model="news" />
        <span class="ml-4">News and announcements</span>
      </div>
      <div class="flex items-center mb-4">
        <vs-switch v-model="product_update" />
        <span class="ml-4">Weekly product updates</span>
      </div>
      <div class="flex items-center">
        <vs-switch v-model="stats" />
        <span class="ml-4">Monthly automation report</span>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end mt-base">
      <vs-button class="ml-auto mt-2" v-on:click="updatePreferences()">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

export default {
  data() {
    return {
      failedEntries: false,
      reportedEntries: false,
      cloudifySupport: false,
      news: false,
      product_update: false,
      stats: false,
    }
  },
  methods: {
    async updatePreferences() {
      //prepare body for update in firestore
      const tempNotificationPref = {
        user: {
          notificationSettings: {
            activity: {
              cloudifySupport: this.cloudifySupport,
              failedEntries: this.failedEntries,
              reportedEntries: this.reportedEntries,
            },
            application: {
              news: this.news,
              product_update: this.product_update,
              stats: this.stats,
            },
          },
        },
      }

      try {
        await firebase
          .firestore()
          .collection('cloudify')
          .doc(JSON.parse(localStorage.getItem('userInfo')).uid)
          .set(tempNotificationPref, { merge: true })
        this.$vs.notify({
          title: 'Notification Updated Successfully',
          color: 'success',
        })
      } catch (err) {
        this.$rollbar.error('Notification Update in firestore Failed', { error: err.message })
        this.$vs.notify({
          title: 'Error Occured',
          text: `${err.message}`,
          color: 'danger',
        })
      }
    },
    //we meed this function to set the pre exisiting values of notification setting to the user. IF EXISTS, otherwise show default values.
    async fetchNotificationSettings() {
      const notificationPref = this.$store.state.DB.user.notificationSettings
      if (notificationPref !== undefined) {
        //activity notification pref
        this.failedEntries = notificationPref.activity.failedEntries
        this.reportedEntries = notificationPref.activity.reportedEntries
        this.cloudifySupport = notificationPref.activity.cloudifySupport
        //application notification pref
        this.news = notificationPref.application.news
        this.product_update = notificationPref.application.product_update
        this.stats = notificationPref.application.stats
      }
    },
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  created() {
    this.fetchNotificationSettings()
  },
}
</script>
